import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getVocabProgressRatio } from 'a/hub/selectors/';
import { useFirstUserInteraction } from 'lib/hooks';
import { advanceToNextWorkshopStep } from 'root/activities/hub/actions/workshopActions';
import { RadioIcon, SuccessPanel, DescriptionText, HeaderText } from '../sharedComponents';

const VocabSuccessModal = ({ closeModal, config }) => {
  const completeRatio = useSelector(getVocabProgressRatio);
  const dispatch = useDispatch();
  const {
    heading = 'Transmission Secured',
    text = '*10 activities* completed. Transmitter recalibrated. *New message* incoming!',
  } = config;

  const firstUserInteraction = useFirstUserInteraction();

  const onClick = (e) => {
    const source = 'VocabSuccessModal';
    dispatch(advanceToNextWorkshopStep(source, true, config.openedAtStep));
    firstUserInteraction(e);
    closeModal(e);
  };

  return (
    <SuccessPanel onConfirm={onClick} actionScope="vocab-success-modal">
      <StyledContainer>
        <HeaderText>{heading}</HeaderText>
        <DescriptionText>{text}</DescriptionText>
      </StyledContainer>
      <RadioIcon top={202} left={347} completeRatio={completeRatio} />
    </SuccessPanel>
  );
};

VocabSuccessModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default VocabSuccessModal;

const StyledContainer = styled.div`
  position: absolute;
  top: 177px;
  left: 486;
  height: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
